<template>
  <div
    v-if="content"
    class="border-gray fixed bottom-5 left-2 z-50 max-w-[97%] rounded-xl border bg-white md:bottom-5 md:left-5 md:max-w-110"
  >
    <div class="flex flex-col gap-3 p-5">
      <div v-html="title[locale]" class="text-xl/[100%]" />
      <div
        v-html="content[locale]"
        class="text-sm leading-[130%] text-pretty md:text-[17px]"
      />
    </div>

    <button
      @click="handleClose"
      class="absolute top-2 right-2 cursor-pointer"
      :aria-label="
        locale === 'cs' ? 'Zavřít oznamení' : 'Close announcement popup'
      "
    >
      <XmarkIcon class="h-3 w-3 xl:h-3.5 xl:w-3.5" />
    </button>
  </div>
</template>

<script setup lang="ts">
import type { LocalizedString } from '~/types'

interface Props {
  title: LocalizedString
  content: LocalizedString
}

const props = defineProps<Props>()
const { locale } = useI18n()

const emit = defineEmits(['close'])

const handleClose = () => {
  emit('close')
}
</script>
